import { Component, ReactNode } from 'react';

export interface IFocusParams {
  hasFocus: boolean;
  onFocus: () => void;
  onBlur: () => void;
}

interface IProps {
  children: (params: IFocusParams) => ReactNode;
}

interface IState {
  hasFocus: boolean;
}

export default class Focus extends Component<IProps, IState> {
  public state = { hasFocus: false };

  public render() {
    const args: IFocusParams = {
      hasFocus: this.state.hasFocus,
      onFocus: this.onFocus,
      onBlur: this.onBlur,
    };

    return this.props.children(args);
  }

  private onFocus = () => {
    this.setState({ hasFocus: true });
  };

  private onBlur = () => {
    this.setState({ hasFocus: false });
  };
}
